import { flattenObject } from 'utils/format/object'
import { EventSenderPlugin } from '.'
import { EventMetadata, SendEventData } from '../types'

export class GoogleAnalyticsPlugin extends EventSenderPlugin {
  constructor() {
    super('GoogleAnalytics')
  }

  sendEvent(event: SendEventData) {
    if (!window.gtag) return

    window.gtag(
      'event',
      event.label,
      event.metadata ? flattenObject(event.metadata) : {}
    )
  }

  updateMetadata(metadata: EventMetadata) {
    if (!window.dataLayer) return

    if (metadata.user_id) {
      window.dataLayer.push({
        user_id: metadata.user_id
      })
    }
  }
}
